import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
      path: '/',
      name: 'ホーム',
      component: () => import('@/views/HomePage.vue'),
    },
    {
      path: '/privacy',
      name: 'プライバシー',
      component: () => import('@/views/PrivacyPolicy.vue'),
    },
  ]
  
  const router = createRouter({ 
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior() {
      // always scroll to top
      return { top: 0 }
    },
  })
  
  export default router